<template>
  <base-page-layout :title="pageTitle">
    <busca-component :search-type="searchType" />
    <export-clients-hotsite v-if="searchType === 'cliente'" />
  </base-page-layout>
</template>

<script>
import BuscaComponent from '@/components/busca-detalhes/BuscaComponent.vue'
import BasePageLayout from '@/components/BasePageLayout.vue'
import ExportClientsHotsite from '@/components/ExportClientsHotsite.vue'

export default {
  components: {
    BuscaComponent,
    BasePageLayout,
    ExportClientsHotsite,
  },
  props: {
    searchType: String,
  },
  computed: {
    pageTitle() {
      return `Busca de ${this.searchType}`
    },
  },
}
</script>

<style lang="scss"></style>
